
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_address",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.Address')
        },
        address() {
            return this.unitLmsgAddress || Object.values(this.unitLmsgLatLng || {}).join(',')
        },
        value() {
            return this.address
        },
        icon() {
            return this.showIcon ? 'sensor__address' : false
        }
    },
}
</script>

<style scoped>

</style>